import { ref } from 'vue'
import api from '@/services/api'

export const notifications = ref<Notification[]>([])

const DISMISSABLE_TYPES = new Set(['task', 'other'])

export interface Notification {
  id: number | string
  title: string
  message?: string
  button: string
  type: 'raffle' | 'airdrop' | 'badge' | 'task' | 'other'
  action?: () => void
  icon?: string | null
  onClose?: () => void
  read?: boolean
}

export function useNotifications() {
  const addNotification = (notification: Notification) => {
    const existingNotification = notifications.value.find((n) => n.id === notification.id)
    if (existingNotification) {
      return existingNotification.id
    }

    notifications.value.push(notification)

    return notification.id
  }

  const removeNotification = (id: number | string) => {
    const index = notifications.value.findIndex((n) => n.id === id)
    if (index > -1) {
      if (notifications.value[index]?.onClose) {
        notifications.value[index].onClose()
      }
      notifications.value.splice(index, 1)
    }
  }

  const readNotification = (id: number | string) => {
    const index = notifications.value.findIndex((n) => n.id === id)
    if (index > -1) {
      const notification = notifications.value[index]
      notification.read = true

      if (DISMISSABLE_TYPES.has(notification.type)) {
        api.dismissNotification(String(id)).catch(() => {})
      }
    }
  }

  const clearAll = () => {
    notifications.value = []
  }

  const clearType = (type: 'raffle' | 'airdrop' | 'badge' | 'task' | 'other') => {
    notifications.value = notifications.value.filter((n) => n.type !== type)
  }

  return {
    notifications,
    addNotification,
    removeNotification,
    readNotification,
    clearAll,
    clearType,
  }
}
